import { render, staticRenderFns } from "./Supplyconfigure.vue?vue&type=template&id=02aff975&scoped=true"
import script from "./Supplyconfigure.vue?vue&type=script&lang=js"
export * from "./Supplyconfigure.vue?vue&type=script&lang=js"
import style0 from "./Supplyconfigure.vue?vue&type=style&index=0&id=02aff975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aff975",
  null
  
)

export default component.exports